import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import UserInfo from "./slices/UserInfo";
import TableData from "./slices/TableData";
import { combineReducers } from "@reduxjs/toolkit";
import ModuleData from "./slices/ModuleData";
import VerifyPassword from "./slices/VerifyPassword";
import OrgDetail from "./slices/OrgDetail";
import SubMenuClick from "./slices/SubMenuClick";
import SubMenuTrakL from "./slices/SubMenuTrakL";
import TableExapneder from "./slices/TableExapneder";
import firstTable from "./slices/firstTable";
import mainAccessData from "./slices/mainAccessData";
import tnmisSubmenu from "./slices/tnmisSubmenu";
import moduleAccessData from "./slices/moduleAccessData";
import messageSlice from "./slices/messageSlice";
import filterSlice from "./slices/filterSlice";
import filterStateSlice from "./slices/filterStateSlice";
import auditfilterSlice from "./slices/auditfilterSlice";
import emailfilterSlice from "./slices/emailfilterSlice";
import customerfilterSlice from "./slices/customerfilterSlice";
import searchSlice from "./slices/searchSlice";
import notificationSlice from "./slices/notificationSlice";
import filterDataReducer from "./slices/filterDataSlice";

const persistConfig = {
  key: "root",
  storage,
  version: 1,
};
const reducer = combineReducers({
  user: UserInfo,
  tableData: TableData,
  moduleData: ModuleData,
  verifyPassword: VerifyPassword,
  orgdeatil: OrgDetail,
  subMenuClick: SubMenuClick,
  subMenuTrakL: SubMenuTrakL,
  tnmisSubmenu: tnmisSubmenu,
  tableExpaneder: TableExapneder,
  firstTable: firstTable,
  mainAccess: mainAccessData,
  moduleAccess: moduleAccessData,
  messageSlice: messageSlice,
  filter: filterSlice,
  filterState: filterStateSlice,
  auditfilter: auditfilterSlice,
  emailfilter: emailfilterSlice,
  customerfilter: customerfilterSlice,
  search: searchSlice,
  notificationList: notificationSlice,
  filterData: filterDataReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
